// index.js

import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom'; // Import HashRouter
import App from './App'; // Your main application component
import './index.css';

ReactDOM.render(
  <Router basename="/"> {/* Set basename here */}
    <App />
  </Router>,
  document.getElementById('root')
);
